import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import reproductive from "../assets/Reproductive.png";
import SummaryApi from "../common/index";

// Import Swiper React components and styles
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Reproductive = () => {
  const [activeFlexPath, setActiveFlexPath] = useState("/products"); // Default fallback
  useEffect(() => {
    const fetchAndFindProduct = async () => {
      try {
        const res = await fetch(SummaryApi.getActiveProduct.url);
        const result = await res.json();
        
       if (result.status && result.data) {
  const product = result.data.find(p => {
    const title = p.product_title?.toLowerCase() || "";
    // Checks if BOTH words exist anywhere in the name
    return title.includes("active") && title.includes("flex");
  });

          if (product) {
            // Encode the ID using btoa just like in your Products page
            const encodedId = window.btoa(product.product_id.toString());
            setActiveFlexPath(`/product/${encodedId}`);
          }
        }
      } catch (error) {
        console.error("Error finding Active Flex product:", error);
      }
    };

    fetchAndFindProduct();
  }, []);
  const highlights = [
    {
      title: "Graphene Wellness Layer",
      description:
        "Designed to help ease period discomfort by reducing menstrual cramps",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      ),
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600",
    },
    {
      title: "Odor Control Technology",
      description:
        "Helps minimize odor buildup for a cleaner and fresher feeling throughout the day.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      ),
      bgColor: "bg-pink-50",
      iconColor: "text-pink-600",
    },
    {
      title: "Antimicrobial Comfort Technology",
      description:
        "Graphene-enhanced layers designed to support freshness and hygiene.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
          />
        </svg>
      ),
      bgColor: "bg-purple-50",
      iconColor: "text-purple-600",
    },
    {
      title: "Thermal Comfort Support",
      description:
        "Advanced graphene materials designed for a cooler, fresher-feeling experience.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
          />
        </svg>
      ),
      bgColor: "bg-purple-50",
      iconColor: "text-purple-600",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-pink-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto">
        {/* PART 1: TOP CONTENT (Image & Text) */}
        <div className="bg-white rounded-3xl overflow-hidden border border-pink-100 flex flex-col lg:flex-row items-center mb-12">
          {/* Image Section */}
          <div className="lg:w-1/2 p-8 bg-white flex justify-center items-center relative">
            <div className="absolute inset-0 bg-pink-100 opacity-20 blur-3xl rounded-full scale-75"></div>
            <img
              src={reproductive}
              alt="Anion Technology"
              className="relative z-10 w-full h-auto max-w-md transform transition duration-500 hover:scale-105"
            />
          </div>

          {/* Content Section */}
          <div className="lg:w-1/2 p-8 lg:p-16">
            <span className="inline-block px-3 py-1 rounded-full bg-pink-100 text-pink-600 text-xs font-bold uppercase tracking-wider mb-4">
              Biotech Wellness
            </span>
            <h1 className="text-4xl font-extrabold text-gray-900 leading-tight mb-6">
              Comfort Beyond Protection
            </h1>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              More than protection — designed to support comfort, freshness, and
              everyday well-being.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-8 space-y-2">
              <li>
                Graphene Wellness Layer: Designed to help ease period discomfort
                by reducing menstrual cramps
              </li>
              <li>
                Odor Control Technology: Helps minimize odor buildup for a
                cleaner and fresher feeling throughout the day.
              </li>
              <li>
                Antimicrobial Comfort Technology: Graphene-enhanced layers
                designed to support freshness and hygiene.
              </li>
              <li>
                Thermal Comfort Support: Advanced graphene materials designed
                for a cooler, fresher-feeling experience.
              </li>
            </ul>
            <Link
             to={activeFlexPath}
              className="inline-block text-center w-full sm:w-auto px-8 py-4 text-lg font-bold text-white bg-pink-600 hover:bg-pink-700 rounded-xl shadow-lg shadow-pink-200 transition-all duration-300 transform hover:-translate-y-1 active:scale-95"
            >
              Experience Total Wellness
            </Link>
          </div>
        </div>

        {/* PART 2: BOTTOM CAROUSEL (Highlights) */}
        <div className="relative">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            className="pb-12"
          >
            {highlights.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`${item.bgColor} p-8 rounded-3xl border border-white shadow-sm h-full flex flex-col transition-all duration-300 hover:shadow-lg hover:-translate-y-1`}
                >
                  <div
                    className={`w-14 h-14 ${item.iconColor} mb-6 flex items-center justify-center rounded-2xl bg-white shadow-sm`}
                  >
                    {item.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Bottom Social Proof section */}
        <div className="mt-12 flex flex-wrap justify-center gap-8 text-gray-400 font-medium">
          <div className="flex items-center gap-2">
            ✓ Gynecologist Recommended
          </div>
          <div className="flex items-center gap-2">
            ✓ Oxygen-Permeable Layers
          </div>
          <div className="flex items-center gap-2">
            ✓ 24-Hour Odor Protection
          </div>
        </div>
      </div>

      {/* Global CSS to style the pagination dots pink */}
      <style>{`
        .swiper-pagination-bullet-active {
          background: #db2777 !important; 
          width: 24px;
          border-radius: 4px;
        }
        .swiper-pagination {
          bottom: 0px !important;
        }
      `}</style>
    </div>
  );
};

export default Reproductive;
